export default "__VITE_ASSET__c0800468__"